type Props = {
  label: string;
};

function BoldLabel({ label }: Props) {
  return <span className="font-bold">{label}</span>;
}

export default BoldLabel;
